import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { EnableClassTelemetry } from 'app/services/otel.service';

@EnableClassTelemetry()
@Injectable()
export class AlertService {
  private snackbarSubject = new Subject<any>();
  lastSnackbarId = '1';
  constructor() {}

  public showToast<T = any>(
    message: string,
    duration = 5000,
    mode = 'default',
    autoDismiss = true,
    elementClassName = '',
    eventType?: string,
    customData?: T
  ) {
    // Unique ID required for xi-snack-bar
    let id: string;
    do {
      id = Math.floor(Math.random() * 100).toString();
    } while (this.lastSnackbarId === id);
    this.snackbarSubject.next({ message, id, duration, mode, autoDismiss });
    this.lastSnackbarId = id;

    if (elementClassName !== '') {
      setTimeout(() => {
        const elements = document.querySelectorAll(`.kxi-snackbar-wrapper .${elementClassName}`);
        for (let i = 0; i < elements.length; i++) {
          const element = elements[i] as HTMLElement;
          element.onclick = function () {
            element.dispatchEvent(
              new CustomEvent(eventType, {
                bubbles: true,
                detail: { data: customData, message },
              })
            );
          };
        }
      }, 100);
    }
  }

  public showErrorToast(errorMessage: string, errorObj?: any) {
    let errorText: string;
    if (errorObj) {
      errorText =
        errorObj?.error?.description ||
        errorObj?.error?.error ||
        errorObj?.data ||
        errorObj?.error?.data ||
        errorObj?.message ||
        '';
    }

    const errorToastMessage = errorText ? `${errorMessage}: ${errorText}` : errorMessage;

    return this.showToast(errorToastMessage, 0, 'error');
  }

  public getSnackbar(): Observable<any> {
    return this.snackbarSubject.asObservable();
  }
}
